import React from 'react';
import { CtaButton } from './CtaButton';
import { PRICE_USD } from '../data/checkout';
export function Closing() {
  return <section className="w-full bg-ink" data-id="element-18" data-mp="3szg4bxp8thrn">
      <div className="mx-auto max-w-5xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-19" data-mp="3t2luzhdisrph">
        <h2 className="max-w-2xl font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl" data-id="element-20" data-mp="3f8uu0xduug5d">
          You have two choices right now
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-21" data-mp="35aezekfmcor4">
          <div className="flex flex-col border border-line bg-surface p-8" data-id="element-22" data-mp="3aajlqr37kdp9">
            <p className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-muted" data-id="element-23" data-mp="2waibwm4ytvxn">
              Option A
            </p>
            <p className="mt-4 font-display text-3xl font-bold uppercase leading-tight tracking-tightest text-muted" data-id="element-24" data-mp="30d580z8o630n">
              Keep doing what you’re doing
            </p>
            <p className="mt-4 font-sans text-base leading-relaxed text-muted" data-id="element-25" data-mp="yl8u5iz14h2p">
              Keep building random workouts and hope your athletes improve by
              luck.
            </p>
            <p className="mt-auto pt-8 font-sans text-sm uppercase tracking-[0.16em] text-muted" data-id="element-26" data-mp="3m3finobtqv29">
              Cost: another season
            </p>
          </div>

          <div className="flex flex-col border border-volt bg-volt p-8" data-id="element-27" data-mp="4oh0vvejrc5c">
            <p className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-ink/70" data-id="element-28" data-mp="3vt7gcrf804ay">
              Option B
            </p>
            <p className="mt-4 font-display text-3xl font-bold uppercase leading-tight tracking-tightest text-ink" data-id="element-29" data-mp="3341keu72ay5y">
              Secure the HYROX Coach Blueprint
            </p>
            <p className="mt-4 font-sans text-base font-medium leading-relaxed text-ink/80" data-id="element-30" data-mp="3hz7q1g28wuyr">
              Build a reputation as the coach who actually delivers results.
              Build a scalable business. Become the authority in your city.
            </p>
            <p className="mt-auto pt-8 font-sans text-sm font-semibold uppercase tracking-[0.16em] text-ink" data-id="element-31" data-mp="saxdpbdod3lb">
              Cost: ${PRICE_USD}, one time
            </p>
          </div>
        </div>

        <div className="mt-14 text-center" data-id="element-32" data-mp="14d8glmx7l3zb">
          <p className="font-display text-4xl font-extrabold uppercase leading-none tracking-tightest text-white sm:text-5xl" data-id="element-33" data-mp="14g2zha0kqgqm">
            The choice is yours.
          </p>
          <div className="mt-8 flex justify-center" data-id="element-34" data-mp="1ebxnkknkh40s">
            <CtaButton className="w-full sm:w-auto" data-id="element-35" data-mp="gp7byp35i7p6" />
          </div>
          <p className="mt-4 font-sans text-xs uppercase tracking-[0.16em] text-muted" data-id="element-36" data-mp="gmuk9k7lciyx">
            Immediate access • Secure payment • 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}